import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "phone",
})
export class PhonePipe implements PipeTransform {
  public transform(value: string = ""): string {
    const firstSlice = value?.slice(0, 3);
    const secondSlice = value?.slice(3, 6);
    const thirdSlice = value?.slice(6, 10);

    return `${firstSlice || ""}${secondSlice ? "-" + secondSlice : ""}${thirdSlice ? "-" + thirdSlice : ""}`;
  }
}
